<template>
  <div class="experience">
    <div class="content">
      <header>
        <span class="title">Experience</span>
        <h2>Building Technology that Powers the World.</h2>
      </header>
      <div class="detail">
<p>With nearly 50 years of combined experience building enterprise software solutions and consumer applications, our core team is equipped with a powerfully diverse set of skills.</p>
<p>Our expertise in research and strategy fortify the foundation of every product we create. Our design process brings an invaluable reassurance that each and every problem is solved with the right solution, and our multifaceted development team outpaces the industry on delivery speed time and time again.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience"
};
</script>

<style lang="scss" scoped>
.experience {
  height: 672px;
  background: #fff url("../../public/img/experience_bg.png") no-repeat bottom
    right;
    @media(max-width: 700px) {
      height: inherit;
      padding-bottom: 128px;
    }

  .content {
    position: relative;
    padding-top: 96px;
    .title {
      display: block;
      width: 100%;
      display: flex;
      color: rgba(0, 0, 0, 0.87);
      font-family: Archia;
      font-size: 12.19px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 16px;
      text-transform: uppercase;
      &:before {
        content: "";
        display: inline-block;
        height: 1px;
        width: 488px;
        background-color: rgba(#000, 0.87);
        position: relative;
        top: 6px;
        margin-right: 8px;
        opacity: 0.3;
            @media(max-width: 700px) {
              width: 64px;
    }
      }
    }
    .detail {
      padding-right: 16px;
      padding-left: 488px;
      padding-right: 142px;
      @media(max-width: 700px) {
        padding-left: 64px;
        padding-right: 16px;
      }
    }
  }
}

h2 {
  height: 24px;
  color: #1a222f;
  font-family: Archia;
  font-size: 20.32px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 24px;
  margin: 44px 0 16px 0;
  padding-left: 488px;
      @media(max-width: 700px) {
        padding-left: 64px;
        padding-right: 16px;
        margin-bottom: 32px;
      }
}

p {
  color: #1a222f;
  font-family: Rubik;
  font-size: 16.26px;
  letter-spacing: 0.5px;
  line-height: 28px;
  margin: 16px 0;
  opacity: .7;
}
</style>